import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Table } from 'primeng/table';
import { ConfirmEventType } from 'primeng/api';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { PageInfo } from 'src/app/core/models/page-info';
import { DetailPageInfo } from 'src/app/core/models/detail-page-info';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { deepCopy, getFacilityByPermission, isNullOrEmpty, isEmpty } from 'src/app/core/utils/common-functions';
import { GovermentUniformInvoiceCheckService } from './../../service/goverment-uniform-invoice-check-service.service';
import { DatePipe } from '@angular/common';
import { FacilityService } from 'src/app/core/services/facility.service';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { startOfDay, endOfDay } from 'date-fns';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
@Component({
  selector: 'laas-evidence-check',
  templateUrl: './evidence-check.component.html',
  styleUrls: ['./evidence-check.component.scss'],
})
export class EvidenceCheckComponent
  extends SessionBaseComponent
  implements OnInit {
  readonly preferenceKey: string;
  isSearchFormOpen: boolean;
  searchForm: any;
  detailParams: any;
  searchParams: any;
  billOriginParams: any;
  statusOptions: any[];
  visibleTaxCodeOptions: any[];
  isHeaderLoading: boolean;
  isDetailLoading: boolean;
  isBillLoading: boolean;
  canEditTable: boolean;
  isBtnApproveVisible: boolean;
  editMode: boolean;
  detailSave: boolean;
  detailEditMode: boolean;
  expenseInvSourceOptions: any[];
  inOutTypeOptions: any[];
  letterOrgIdList: any[];
  billCorpList: any[];
  bookingVendorOptions: any[];
  detailColumns: any[];
  selectedTableColumns: any[];
  selectedDetailTableColumns: any[];
  billColumns: any[];
  selectedBillTableColumns: any[];
  tableColumns: any[];
  tableValue: any[];
  detailTableValue: any[];
  billTableValue: any[];
  selectedRowsWithCheckBox: any[];
  selectedDetailRowsWithCheckBox: any[];
  sortInfo: any[];
  detailSortInfo: any[];
  billSortInfo: any[];
  cloneTableValue: any;
  cloneDetailTableValue: any;
  cloneBillTableValue: any;
  previousSelectedRow: any;
  previousDetailSelectedRow: any;
  selectedRow: any;
  selectedDetailRows: any;
  selectedBillRows: any;
  updateGUIID: any[];
  updateDetailGUIId: any[];
  invoiceTypeOptions: any[];
  accountCodeDetailOptions: any[];
  taxCodeOptions: any[];
  taxCodeOptionsCompare: any[];
  paymentMethodOptions: any[];
  billTypeOptions: any[];
  currencyOptions: any[];
  formatTypeOptions: any[];
  accountCodeOptions: any[];
  accountCodeBigOptions: any[];
  carrierPaymentByOptions: any[];
  termsIdOptions: any[];
  rowTaxList: any[];
  headerChecked: boolean;
  detailChecked: boolean;
  editStatus: any;
  selectedRowCount: any;
  selectedRowTotal: any;
  first: number;
  isForwarder: boolean;
  detailChange: boolean;
  saveSuccess: boolean;

  pageDropDownList: number[];

  pageInfo: PageInfo;
  detailPageInfo: DetailPageInfo;
  billPageInfo: PageInfo;

  readonly viewPermissionCode = PermissionConstants.ViewGUICheck;
  readonly editPermissionCode = PermissionConstants.EditGUICheck;
  @ViewChild('evidenceTable') dataTable!: Table;
  @ViewChild('detailEvidenceTable') detailDataTable!: Table;
  @ViewChild('guiNoDt') guiNoDt!: CalendarComponent;
  @ViewChild('createDt') createDt!: CalendarComponent;
  currentLang: string = this.laasSetting.language;

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private govermentUniformInvoiceCheckService: GovermentUniformInvoiceCheckService,
    private commonDataService: CommonDataService,
    private dropdownOptionsService: DropdownOptionsService,
    private facilityService: FacilityService
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.EvidenceCheck;
    this.isSearchFormOpen = true;
    this.statusOptions = [];
    this.selectedTableColumns = [];
    this.selectedDetailTableColumns = [];
    this.selectedBillTableColumns = [];
    this.selectedRowsWithCheckBox = [];
    this.selectedDetailRowsWithCheckBox = [];
    this.billColumns = [];
    this.updateGUIID = [];
    this.updateDetailGUIId = [];
    this.taxCodeOptions = [];
    this.taxCodeOptionsCompare = [];
    this.visibleTaxCodeOptions = [];
    this.expenseInvSourceOptions = [];
    this.paymentMethodOptions = [];
    this.accountCodeOptions = [];
    this.accountCodeDetailOptions = [];
    this.accountCodeBigOptions = [];
    this.currencyOptions = [];
    this.inOutTypeOptions = [];
    this.tableColumns = [];
    this.detailColumns = [];
    this.billCorpList = [];
    this.letterOrgIdList = [];
    this.bookingVendorOptions = [];
    this.invoiceTypeOptions = [];
    this.formatTypeOptions = [];
    this.billTypeOptions = [];
    this.carrierPaymentByOptions = [];
    this.termsIdOptions = [];
    this.tableValue = [];
    this.detailTableValue = [];
    this.billTableValue = [];
    this.sortInfo = [];
    this.detailSortInfo = [];
    this.billSortInfo = [];
    this.rowTaxList = [];
    this.isHeaderLoading = false;
    this.isDetailLoading = false;
    this.isBillLoading = false;
    this.canEditTable = false;
    this.isBtnApproveVisible = false;
    this.headerChecked = false;
    this.editMode = false;
    this.detailChecked = false;
    this.detailEditMode = false;
    this.detailSave = true;
    this.first = 0;
    this.isForwarder = false;
    this.detailChange = false;

    this.selectedRowCount = 0;
    this.selectedRowTotal = 0;

    this.saveSuccess = false;

    this.pageInfo = {
      pageSize: 100,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };

    this.detailPageInfo = {
      pageSize: 100,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };

    this.billPageInfo = {
      pageSize: 100,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };

    this.pageDropDownList = [100, 300, 500];

    this.commonDataService
      .getCodeConverter(
        this.laasSetting.language,
        'DropdownList',
        'ExpenseInvSourceModel'
      )
      .subscribe({
        next: (result) => {
          this.expenseInvSourceOptions = [...result].map((x: any) => {
            return {
              label: `${x.codeKey}-${x.codeDesc}`,
              value: x.codeKey,
            };
          });
        },
      });

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (result) => {
        this.carrierPaymentByOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      },
    });

    this.commonDataService
      .getCodeConverter(this.laasSetting.language, 'DropdownList', 'BillType')
      .subscribe({
        next: (result) => {
          this.billTypeOptions = [...result].map((x: any) => {
            return {
              label: `${x.codeKey}-${x.codeDesc}`,
              value: x.codeKey,
            };
          });
        },
      });

    this.commonDataService
      .getCodeConverter(
        this.laasSetting.language,
        'DropdownList',
        'InvoiceType'
      )
      .subscribe({
        next: (result) => {
          this.invoiceTypeOptions = [...result].map((x: any) => {
            return {
              label: `${x.codeKey}-${x.codeDesc}`,
              value: x.codeKey,
            };
          });
        },
      });

    this.commonDataService
      .getCodeConverter(
        this.laasSetting.language,
        'DropdownList',
        'OriginFormatType'
      )
      .subscribe({
        next: (result) => {
          this.formatTypeOptions = [...result].map((x: any) => {
            return {
              label: `${x.codeDesc}`,
              value: x.codeKey,
            };
          });
        },
      });

    this.commonDataService
      .getCodeConverter(this.laasSetting.language, 'DropdownList', 'InOutType')
      .subscribe({
        next: (result) => {
          this.inOutTypeOptions = [...result].map((x: any) => {
            return {
              label: `${x.codeKey}-${x.codeDesc}`,
              value: x.codeKey,
            };
          });
        },
      });

    this.facilityService.getCurrencyOptions().subscribe({
      next: (result) => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      },
    });

    this.facilityService.getExpenseOptions('PaymentMethod', null).subscribe({
      next: (result) => {
        this.paymentMethodOptions = [...result].map((x: any) => {
          return {
            value: `${x.optionCode}`,
            label: `${x.optionCode}-${x.optionDesc}`,
          };
        });
      },
    });

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (result) => {
        this.bookingVendorOptions = result;
      },
    });

    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, '').subscribe({
      next: (result) => {
        this.billCorpList = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode} - ${x.legalEntityOUName}`,
            value: x.legalEntityOUCode,
          };
        });
      },
    });
    this.dropdownOptionsService.getDetailBillAccountCode().subscribe({
      next: (result) => {
        this.accountCodeDetailOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      },
    });

    this.dropdownOptionsService.getBillAccountCode().subscribe({
      next: (result) => {
        this.accountCodeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      },
    });

    this.facilityService
      .getExpenseOptions('SHT_BILL_ORIGIN.TERMS', null)
      .subscribe({
        next: (result) => {
          this.termsIdOptions = [...result].map((x: any) => {
            return {
              value: `${x.optionCode}`,
              label: `${x.optionCode}-${x.optionDesc}`,
            };
          });
        },
      });

    this.searchForm = this.fb.group({
      guiIdStart: null,
      guiIdEnd: null,
      guiNoStart: null,
      guiNoEnd: null,
      guiDtStart: null,
      guiDtEnd: null,
      vendorNo: null,
      billCorp: null,
      createDtStart: null,
      createDtEnd: null,
      status: null,
      inOutType: null,
      sourceModel: null,
      erpApKeyStart: null,
      erpApKeyEnd: null,
      invoiceId: [],
      flowNo: [],
      userType: null,
      pageSize: null,
      pageIndex: null,
      sortInfo: null,
      facilityList: [null],
    });

    this.detailParams = {
      guiId: null,
      pageSize: null,
      pageIndex: null,
      sortInfo: null,
    };

    this.billOriginParams = {
      guiId: null,
      accountCode: null,
      pageSize: null,
      pageIndex: null,
      sortInfo: null,
    };


  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.commonDataService
      .getCodeConverter(
        this.laasSetting.language,
        'DropdownList',
        'BillingStatus'
      )
      .subscribe({
        next: (result) => {
          this.tableColumns = this.tableTranslation();
          this.selectedTableColumns = this.tableColumns;
          this.detailColumns = this.detailTableTranslation();
          this.selectedDetailTableColumns = this.detailColumns;
          this.billColumns = this.billTableTranslation();
          this.selectedBillTableColumns = this.billColumns;
          this.statusOptions = [...result].map((x: any) => {
            return {
              label: `${x.codeKey}-${x.codeDesc}`,
              value: x.codeKey,
            };
          });
        },
      });

    this.canEditTable = this.permissionCodes.includes(this.editPermissionCode);
    var canInPage = this.permissionCodes.includes(this.viewPermissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    if (this.userProfile.userType == "Forwarder") {
      this.searchForm.get("vendorNo")?.patchValue(this.userProfile.roles[0].scopes[0].forwarderCode)
      this.isForwarder = true;
    }

    if (this.userProfile.userType === UserType.SuperAdmin.toString() ||
        this.permissionCodes.includes(PermissionConstants.BtnApproveGUI)) {
      this.isBtnApproveVisible = true;
    }
  }

  @Input() get selectedColumns(): any[] {
    return this.selectedTableColumns;
  }

  @Input() get selectedDetailColumns(): any[] {
    return this.selectedDetailTableColumns;
  }

  @Input() get selectedBillColumns(): any[] {
    return this.selectedBillTableColumns;
  }

  set selectedColumns(cols: any[]) {
    this.selectedTableColumns = this.tableColumns.filter((col) =>
      cols.includes(col)
    );
  }

  set selectedDetailColumns(cols: any[]) {
    this.selectedDetailTableColumns = this.detailColumns.filter((col) =>
      cols.includes(col)
    );
  }

  set selectedBillColumns(cols: any[]) {
    this.selectedBillTableColumns = this.billColumns.filter((col) =>
      cols.includes(col)
    );
  }

  accordionTabOpen(): void {
    this.isSearchFormOpen = true;
  }

  resetClickBtn(event: any): void {
    this.searchForm.reset();
    if (this.userProfile.userType == "Forwarder") {
      this.searchForm.get("vendorNo")?.patchValue(this.userProfile.roles[0].scopes[0].forwarderCode)
      this.isForwarder = true;
    }
    this.createDt.ngOnInit();
    this.guiNoDt.ngOnInit();
  }

  searchClickBtn(event: any): void {
    console.log('params: ' + JSON.stringify(this.searchForm.value));
    let cloneSearchParams = deepCopy(this.searchForm.value);
    cloneSearchParams.userType = this.userProfile.userType;
    if (this.detailNotSaveConfirm() || this.notSaveConfirm()) {
      this.confirmationService.confirm({
        message: this.translateService.instant(
          'EvidenceCheck.Confirm.SaveOrNot'
        ),
        header: this.translateService.instant('EvidenceCheck.Confirm.Header'),
        icon: 'pi pi-info-circle',
        accept: async () => {
          await this.saveDetailChange();
          await this.saveChange();
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              this.resetPageInfo();
              this.sendSearchRequest();
              break;
            case ConfirmEventType.CANCEL:
              break;
          }
        },
      });

    } else {
      this.dataTable.cancelRowEdit(this.selectedRow);
      if (this.selectedRow) {
        this.detailDataTable.cancelRowEdit(this.selectedRow);
      }
      this.editMode = false;
      this.resetPageInfo();
      this.sendSearchRequest();
    }
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.sendSearchRequest();
  }

  detailTablePageChange(event: any) {
    this.detailPageInfo.pageSize = event.rows;
    this.detailPageInfo.pageIndex = event.first / this.detailPageInfo.pageSize;
    this.getDetailGovermentUniformInvoiceData();
  }

  billTablePageChange(event: any) {
    this.billPageInfo.pageSize = event.rows;
    this.billPageInfo.pageIndex = event.first / this.billPageInfo.pageSize;
    this.getBillingOriginData();
  }

  tableSort(event: any): void {
    this.sortInfo = [{ property: event.field, direction: event.order }];
    this.resetPageInfo();
    this.sendSearchRequest();
  }

  detailTableSort(event: any): void {
    this.detailSortInfo = [{ property: event.field, direction: event.order }];
    this.getDetailGovermentUniformInvoiceData();
  }

  billTableSort(event: any): void {
    this.billSortInfo = [{ property: event.field, direction: event.order }];
    this.getBillingOriginData();
  }

  sendSearchRequest() {
    this.selectedRowCount = 0;
    this.selectedRowTotal = 0;
    let govermentSearchParams = deepCopy(this.searchForm.value);
    govermentSearchParams.facility = this.laasSetting.facility;
    govermentSearchParams.userType = this.userProfile.userType;
    govermentSearchParams.userId = this.userProfile.userName;
    govermentSearchParams.userUUID = this.userProfile.uuid;
    govermentSearchParams.authToken = this.authenticationService.currentToken;
    govermentSearchParams.pageSize = this.pageInfo.pageSize;
    govermentSearchParams.pageIndex = this.pageInfo.pageIndex;
    govermentSearchParams.sortInfo = this.sortInfo;
    if (isEmpty(govermentSearchParams.facilityList)) {
      govermentSearchParams.facilityList = getFacilityByPermission(this.userProfile, "ViewGUICheck");
    }
    this.isHeaderLoading = true;
    this.govermentUniformInvoiceCheckService
      .getGovermentUniformInvoice(govermentSearchParams)
      .subscribe({
        next: (result) => {
          const pageList = result.content;
          this.tableValue = deepCopy(pageList);
          this.putRowId(this.tableValue);

          for (const row of this.tableValue) {
            if (!isNullOrEmpty(row.guiDt)) {
              row.guiDt = new Date(row.guiDt);
            }
          }

          for (const row of this.tableValue) {
            if (!isNullOrEmpty(row.dueDt)) {
              row.dueDt = new Date(row.dueDt);
            }
          }

          this.cloneTableValue = deepCopy(this.tableValue);

          //更改總數量資料
          this.pageInfo.totalRecords = result.totalElements;
          if (this.pageInfo.totalRecords > 500) {
            if (this.pageDropDownList.length == 4) {
              this.pageDropDownList[3] = this.pageInfo.totalRecords
            } else {
              this.pageDropDownList.push(this.pageInfo.totalRecords);
            }
          } else {
            this.pageDropDownList = [100, 300, 500];
          }

          this.isHeaderLoading = false;
          this.isSearchFormOpen = false;
          // 重新抓取資料後取消編輯
          this.selectedRow = this.tableValue[0];
          this.detailTableValue = [];
          this.getDetailGovermentUniformInvoiceData();
          this.dataTable.cancelRowEdit(this.previousSelectedRow);
          this.editMode = false;
          this.headerChecked = false;
          this.selectedRowsWithCheckBox = [];
        },
      });
  }

  putRowId(array: any[]) {
    let rowId = 1;
    for (const val of array) {
      val.rowId = rowId;
      rowId = rowId + 1;
    }
  }

  putDetailRowId(array: any[]) {
    let detailRowId = 1;
    for (const val of array) {
      val.detailRowId = detailRowId;
      detailRowId = detailRowId + 1;
    }
  }

  putBillRowId(array: any[]) {
    let billRowId = 1;
    for (const val of array) {
      val.billRowId = billRowId;
      billRowId = billRowId + 1;
    }
  }

  tableTranslation(): any[] {
    var fields: string[];
    var jsons: string[];
    var tmpcolumn: any[] = [];

    fields = [
      'erpApKey',
      'guiId',
      'billCorp',
      'carrierPaymentBy',
      'status',
      'rejectedReason',
      'flowNo',
      'shippingDescription',
      'amountDifferenceDescription',
      'guiNo',
      'guiDt',
      'guiCurrency',
      'guiAmount',
      'description',
      'setOfBooksId',
      'erpCarrierPaymentSiteId',
      'termsId',
      'paymentMethod',
      'dueDt',
      'glDt',
      'applyAmount',
      'crdDt',
      'checkNo',
      'sourceModel',
      'amountDifferenceColorFlag',
      'approvedFlow',
      'applyDt',
      'transERPErrorMsg',
      'createUser',
      'createDt',
      'updateUser',
      'updateDt',
      'facility',
    ];

    jsons = [
      'EvidenceCheck.MainTable.Column.ERPAPKey',
      'EvidenceCheck.MainTable.Column.GUIId',
      'EvidenceCheck.MainTable.Column.OrgId',
      'EvidenceCheck.MainTable.Column.VendorName',
      'EvidenceCheck.MainTable.Column.Status',
      'EvidenceCheck.MainTable.Column.RejectedReason',
      'EvidenceCheck.MainTable.Column.FlowNo',
      'EvidenceCheck.MainTable.Column.ShippingDescription',
      'EvidenceCheck.MainTable.Column.AmountDifferenceDescription',
      'EvidenceCheck.MainTable.Column.GUINo',
      'EvidenceCheck.MainTable.Column.GUIDt',
      'EvidenceCheck.MainTable.Column.GUICurrency',
      'EvidenceCheck.MainTable.Column.GUIAmount',
      'EvidenceCheck.MainTable.Column.Description',
      'EvidenceCheck.MainTable.Column.SetOfBooksId',
      'EvidenceCheck.MainTable.Column.VendorSiteId',
      'EvidenceCheck.MainTable.Column.TermsId',
      'EvidenceCheck.MainTable.Column.PaymentMethod',
      'EvidenceCheck.MainTable.Column.DueDt',
      'EvidenceCheck.MainTable.Column.GLDt',
      'EvidenceCheck.MainTable.Column.ApplyAmount',
      'EvidenceCheck.MainTable.Column.CRDDt',
      'EvidenceCheck.MainTable.Column.CheckNo',
      'EvidenceCheck.MainTable.Column.SourceModel',
      'EvidenceCheck.MainTable.Column.AmountDifferenceColorFlag',
      'EvidenceCheck.MainTable.Column.ConfirmedUser',
      'EvidenceCheck.MainTable.Column.ApplyDt',
      'EvidenceCheck.MainTable.Column.TransERPErrorMsg',
      'EvidenceCheck.MainTable.Column.CreateUser',
      'EvidenceCheck.MainTable.Column.CreateDt',
      'EvidenceCheck.MainTable.Column.UpdateUser',
      'EvidenceCheck.MainTable.Column.UpdateDt',
      'BookingSearch.Form.Facility',
    ];

    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i]).subscribe((translation: string) => {
        //建立日期 || 更新時間
        if (
          i == 10 ||
          i == 18 ||
          i == 19 ||
          i == 21 ||
          i == 26 ||
          i == 29 ||
          i == 31
        ) {
          tmpcolumn[i] = {
            field: fields[i],
            header: translation,
            dataType: 'date',
            sort: true,
          };
        } else {
          tmpcolumn[i] = { field: fields[i], header: translation, sort: true };
        }
      });
    }
    return tmpcolumn;
  }

  detailTableTranslation(): any[] {
    var fields: string[];
    var jsons: string[];
    var tmpcolumn: any[] = [];

    fields = [
      'seqNo',
      'invoiceType',
      'accountCode',
      'salerNo',
      'salerName',
      'formatType',
      'taxCode',
      'vatCode',
      'amount',
      'guiTaxAmount',
      'guiAmountWithoutTax',
      'originalGUINo',
      'guiDt',
      'guiAmount',
      'guiCurrency',
      'linePayCurrency',
      'linePayAmount',
      'estimatedAmount',
      'linePayRate',
      'expressBill',
      'importDeclarationNo',
      'description',
      'cutCode',
      'linePayRateAf',
      'lineDescription',
      'createUser',
      'createDt',
      'updateUser',
      'updateDt',
      'orgId',
      'lineBaseAmount',
      'payBaseAmount',
    ];

    jsons = [
      'EvidenceCheck.DetailTable.Column.SeqNo',
      'EvidenceCheck.DetailTable.Column.InvoiceType',
      'EvidenceCheck.DetailTable.Column.AccountName',
      'EvidenceCheck.DetailTable.Column.SalerNo',
      'EvidenceCheck.DetailTable.Column.SalerName',
      'EvidenceCheck.DetailTable.Column.FormatType',
      'EvidenceCheck.DetailTable.Column.TaxCode',
      'EvidenceCheck.DetailTable.Column.VatCode',
      'EvidenceCheck.DetailTable.Column.Amount',
      'EvidenceCheck.DetailTable.Column.GUITaxAmount',
      'EvidenceCheck.DetailTable.Column.GUIAmountWithoutTax',
      'EvidenceCheck.DetailTable.Column.OriginalGUINo',
      'EvidenceCheck.DetailTable.Column.GUIDt',
      'EvidenceCheck.DetailTable.Column.GUIAmount',
      'EvidenceCheck.DetailTable.Column.LineBaseCurrency',
      'EvidenceCheck.DetailTable.Column.LinePayCurrency',
      'EvidenceCheck.DetailTable.Column.LinePayAmount',
      'EvidenceCheck.DetailTable.Column.EstimatedAmount',
      'EvidenceCheck.DetailTable.Column.LinePayRate',
      'EvidenceCheck.DetailTable.Column.ExpressBill',
      'EvidenceCheck.DetailTable.Column.ImportDeclarationNo',
      'EvidenceCheck.DetailTable.Column.Description',
      'EvidenceCheck.DetailTable.Column.CutCode',
      'EvidenceCheck.DetailTable.Column.LinePayRateAf',
      'EvidenceCheck.DetailTable.Column.LineDescription',
      'EvidenceCheck.DetailTable.Column.CreateUser',
      'EvidenceCheck.DetailTable.Column.CreateDt',
      'EvidenceCheck.DetailTable.Column.UpdateUser',
      'EvidenceCheck.DetailTable.Column.UpdateDt',
      'EvidenceCheck.DetailTable.Column.OrgId',
      'EvidenceCheck.DetailTable.Column.LineBaseAmount',
      'EvidenceCheck.DetailTable.Column.PayBaseAmount',
    ];

    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i]).subscribe((translation: string) => {
        //建立日期 || 更新時間
        if (i == 12 || i == 26 || i == 28) {
          tmpcolumn[i] = {
            field: fields[i],
            header: translation,
            dataType: 'date',
            sort: true,
          };
        } else {
          tmpcolumn[i] = { field: fields[i], header: translation, sort: true };
        }
      });
    }
    return tmpcolumn;
  }

  billTableTranslation(): any[] {
    var fields: string[];
    var jsons: string[];
    var tmpcolumn: any[] = [];

    fields = [
      'seqNo',
      'billingNo',
      'opexOrgId',
      'billCorp',
      'guiId',
      'guiNo',
      'expressBill',
      'carrierPaymentBy',
      'billingStatus',
      'preCurrencyCode',
      'estimatedAmount',
      'guiAmount',
      'amount',
      'linePayAmount',
      'businessTaxBaseAmount',
      'applyAmount',
      'applyDt',
      'accountCode',
      'billType',
      'uploadBatchNo',
      'guiDt',
      'invoiceType',
      'guiCurrency',
      'description',
      'vendorDescription',
      'paymentMethod',
      'termsId',
      'dueDt',
      'linePayCurrency',
      'linePayRate',
      'confirmDescription',
      'confirmBy',
      'applyDt',
      'cancelDt',
      'cancelUser',
      'cancelDesc',
      'createUser',
      'createDt',
      'updateUser',
      'updateDt',
      'facility',
      'inOutType',
      'diffRatio',
    ];

    jsons = [
      'BillSearch.MainTable.Column.SeqNo',
      'BillSearch.MainTable.Column.InOutKey',
      'BillSearch.MainTable.Column.OpexOrgId',
      'BillSearch.MainTable.Column.BillCorp',
      'BillSearch.MainTable.Column.GUIId',
      'BillSearch.MainTable.Column.GUINo',
      'BillSearch.MainTable.Column.ExpressBill',
      'BillSearch.MainTable.Column.VendorName',
      'BillSearch.MainTable.Column.Status',
      'BillSearch.MainTable.Column.PreCurrencyCode',
      'BillSearch.MainTable.Column.EstimatedAmount',
      'BillSearch.MainTable.Column.GUIAmount',
      'BillSearch.MainTable.Column.Amount',
      'BillSearch.MainTable.Column.LinePayAmount',
      'BillSearch.MainTable.Column.BusinessTaxBaseAmount',
      'BillSearch.MainTable.Column.ApplyAmount',
      'BillSearch.MainTable.Column.ApplyDt',
      'BillSearch.MainTable.Column.AccountCode',
      'BillSearch.MainTable.Column.BillType',
      'BillSearch.MainTable.Column.UploadBatchNo',
      'BillSearch.MainTable.Column.GUIDt',
      'BillSearch.MainTable.Column.InvoiceType',
      'BillSearch.MainTable.Column.GUICurrency',
      'BillSearch.MainTable.Column.Description',
      'BillSearch.MainTable.Column.VendorDescription',
      'BillSearch.MainTable.Column.PaymentMethod',
      'BillSearch.MainTable.Column.TermsId',
      'BillSearch.MainTable.Column.DueDt',
      'BillSearch.MainTable.Column.LinePayCurrency',
      'BillSearch.MainTable.Column.LinePayRate',
      'BillSearch.MainTable.Column.ConfirmDescription',
      'BillSearch.MainTable.Column.ConfirmBy',
      'BillSearch.MainTable.Column.ApplyDt',
      'BillSearch.MainTable.Column.CancelDt',
      'BillSearch.MainTable.Column.CancelUser',
      'BillSearch.MainTable.Column.CancelDesc',
      'BillSearch.MainTable.Column.CreateUser',
      'BillSearch.MainTable.Column.CreateDt',
      'BillSearch.MainTable.Column.UpdateUser',
      'BillSearch.MainTable.Column.UpdateDt',
      'BillSearch.MainTable.Column.Facility',
      'BillSearch.MainTable.Column.InOutType',
      'BillSearch.MainTable.Column.DiffRatio',
    ];

    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i]).subscribe((translation: string) => {
        //建立日期 || 更新時間
        if (
          i == 16 ||
          i == 20 ||
          i == 27 ||
          i == 32 ||
          i == 33 ||
          i == 37 ||
          i == 39
        ) {
          tmpcolumn[i] = {
            field: fields[i],
            header: translation,
            dataType: 'date',
            sort: true,
          };
        } else {
          tmpcolumn[i] = { field: fields[i], header: translation, sort: true };
        }
      });
    }
    return tmpcolumn;
  }

  getDetailGovermentUniformInvoiceData() {
    let detailgovermentSearchParams = deepCopy(this.detailParams);
    detailgovermentSearchParams.pageSize = this.detailPageInfo.pageSize;
    detailgovermentSearchParams.pageIndex = this.detailPageInfo.pageIndex;
    detailgovermentSearchParams.sortInfo = this.detailSortInfo;
    this.isDetailLoading = true;
    if (this.selectedRow) {
      if (this.selectedRow.guiId) {
        detailgovermentSearchParams.guiId = this.selectedRow.guiId;
        this.detailParams.guiId = this.selectedRow.guiId;
        this.govermentUniformInvoiceCheckService
          .getDetailGovermentUniformInvoiceData(detailgovermentSearchParams)
          .subscribe({
            next: (result) => {
              this.detailTableValue = result;
              const pageList = result.content;
              this.detailTableValue = deepCopy(pageList);
              this.putDetailRowId(this.detailTableValue);
              this.getTaxCodeOptions(this.selectedRow.billCorp);
              this.getTaxCodeOptionsCompare(this.selectedRow.billCorp);
              this.cloneDetailTableValue = deepCopy(this.detailTableValue);

              // 日期轉換
              for (const row of this.tableValue) {
                if (!isNullOrEmpty(row.guiDt)) {
                  row.guiDt = new Date(row.guiDt);
                }
              }
              for (const row of this.tableValue) {
                if (!isNullOrEmpty(row.dueDt)) {
                  row.dueDt = new Date(row.dueDt);
                }
              }

              this.detailPageInfo.totalRecords = result.totalElements;

              this.isSearchFormOpen = false;
              this.isDetailLoading = false;
              // 重新抓取資料後取消編輯
              this.selectedDetailRows = this.detailTableValue[0];

              this.detailDataTable.cancelRowEdit(this.selectedDetailRows);
              this.getDetailTableAccountCodeOption();
              this.getBillingOriginData();
              this.selectedDetailRowsWithCheckBox = [];
              this.detailChecked = false;
            },
          });
      } else {
        this.detailTableValue = [];
        this.billTableValue = [];
      }
      this.selectedDetailRows = [];
    }
  }

  govermentUniformInvoiceDownlondBtn(tyep : number): void {
    if(this.pageInfo.totalRecords == 0){
      this.toastService.info(this.translateService.instant('NoEvidenceCheck.TickInformation'));
      return;
    }
    this.loader.show();
    if (this.selectedRowsWithCheckBox.length == 0) {
      let govermentSearchParams = deepCopy(this.searchForm.value);
      govermentSearchParams.facility = this.laasSetting.facility;
      govermentSearchParams.userType = this.userProfile.userType;
      govermentSearchParams.userId = this.userProfile.userName;
      govermentSearchParams.userUUID = this.userProfile.uuid;
      govermentSearchParams.authToken = this.authenticationService.currentToken;
      govermentSearchParams.pageSize = this.pageInfo.totalRecords;
      govermentSearchParams.pageIndex = 0;
      govermentSearchParams.sortInfo = this.sortInfo;
      govermentSearchParams.facilityList = getFacilityByPermission(this.userProfile, "ViewGUICheck");
      this.govermentUniformInvoiceCheckService
      .getGovermentUniformInvoice(govermentSearchParams)
      .subscribe({
        next: (result) => {
          let guiIds = result.content.map((a: { guiId: any; }) => a.guiId);
          if(tyep == 1){
            this.getGovermentUniformInvoiceExcel(guiIds);
          }else{
            this.getGovermentUniformInvoicePdf(guiIds);
          }
        },
      });

    }else{
      let guiIds = this.selectedRowsWithCheckBox.map((a) => a.guiId);
      if(tyep == 1){
        this.getGovermentUniformInvoiceExcel(guiIds);
      }else{
        this.getGovermentUniformInvoicePdf(guiIds);
      }
    }

  }

  getGovermentUniformInvoiceExcel(guiIds : any[]){
    this.loader.show();
    let fileDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    let params = {
      facility: this.laasSetting.facility,
      guiIds: guiIds,
    };
    this.govermentUniformInvoiceCheckService
      .getGovermentUniformInvoiceExcel(params)
      .subscribe({
        next: (result) => {
          if (result == null || result.size == 0) {
            this.translateService.get('EvidenceCheck.NoFound')
            .subscribe({
              next: msg => {
                this.toastService.info(msg);
                this.loader.hide();
              }
            });
          } else {
            const file = result;
            file.name = fileDate + '_有憑下載';
            const url = URL.createObjectURL(file);
            let a: any = document.createElement('a');
            a.href = url;
            a.download = file.name;
            a.click();
            URL.revokeObjectURL(url);
          }
          this.loader.hide();
        },
        complete: () => {
          this.loader.hide();
        },
      });
  }

  getGovermentUniformInvoicePdf(guiIds : any[]): void {
    let fileDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    let params = {
      facility: this.laasSetting.facility,
      guiIds: guiIds,
    };

    this.loader.show();
    this.govermentUniformInvoiceCheckService
      .getGovermentUniformInvoicePdf(params)
      .subscribe({
        next: (result) => {
          if (result == null || result == 0) {
            this.toastService.info(this.translateService.instant('EvidenceCheck.NoFound'));
            this.loader.hide();
          } else {
            const byteStr = atob(result.file);
            const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
            const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < byteStr.length; i++) {
              int8Array[i] = byteStr.charCodeAt(i);
            }
            const data: Blob = new Blob([int8Array], {
              type: 'application/pdf',
            });
            const url = URL.createObjectURL(data);
            const linkEle = document.createElement('a');
            linkEle.href = url;
            linkEle.download = fileDate + '_有憑下載';
            linkEle.click();
            URL.revokeObjectURL(url);
            linkEle.remove();

            this.loader.hide();
          }
        },
        complete: () => { },
      });
  }

  approveBtnClick(): void {
    const updateObj = {
      guiIds: this.selectedRowsWithCheckBox.map((x) => x.guiId),
      updateUser: this.userProfile.userName,
      employeeCode: this.userProfile.employCode
    };
    this.isHeaderLoading = true;
    this.isDetailLoading = true;
    this.isBillLoading = true;
    this.govermentUniformInvoiceCheckService
      .approveGovermentUniformInvoice(updateObj)
      .subscribe({
        next: (result) => {
          this.toastService.success(this.translateService.instant('EvidenceCheck.ApprovedSuccess'));
          this.searchClickBtn(null);
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
          this.isHeaderLoading = false;
          this.isDetailLoading = false;
          this.isBillLoading = false;
        },
      });
  }

  rejectBtnClick(): void {
    const updateObj = {
      guiIds: this.selectedRowsWithCheckBox.map((x) => x.guiId),
      updateUser: this.userProfile.userName,
    };
    this.isHeaderLoading = true;
    this.isDetailLoading = true;
    this.isBillLoading = true;
    this.govermentUniformInvoiceCheckService
      .rejectGovermentUniformInvoice(updateObj)
      .subscribe({
        next: (result) => {
          this.toastService.success(this.translateService.instant('EvidenceCheck.ReturnSuccess'));
          this.searchClickBtn(null);
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
          this.isHeaderLoading = false;
          this.isDetailLoading = false;
          this.isBillLoading = false;
        },
      });
  }

  resendBtnClick(): void {
    const updateObj = {
      guiIds: this.selectedRowsWithCheckBox.map((x) => x.guiId),
      updateUser: this.userProfile.userName,
    };

    this.isHeaderLoading = true;
    this.isDetailLoading = true;
    this.isBillLoading = true;
    this.govermentUniformInvoiceCheckService
      .resendGovermentUniformInvoice(updateObj)
      .subscribe({
        next: (result) => {
          this.toastService.success(this.translateService.instant('EvidenceCheck.ResendSuccess'));
          this.searchClickBtn(null);
        },
        error: (err) => {
          this.isHeaderLoading = false;
          this.isDetailLoading = false;
          this.isBillLoading = false;
          this.toastErrorMessage(err.error);
        },
      });
  }

  erpFlowBtnClick(): void {
    const updateObj = {
      guiIds: this.selectedRowsWithCheckBox.map((x) => x.guiId),
      updateUser: this.userProfile.userName,
    };

    this.isHeaderLoading = true;
    this.isDetailLoading = true;
    this.isBillLoading = true;
    this.govermentUniformInvoiceCheckService
      .erpFlowGovermentUniformInvoice(updateObj)
      .subscribe({
        next: (result) => {
          this.toastService.success(this.translateService.instant('EvidenceCheck.SignedSuccessfully'));
          this.searchClickBtn(null);
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
          this.isHeaderLoading = false;
          this.isDetailLoading = false;
          this.isBillLoading = false;
        },
      });
  }

  getBillingOriginData() {
    this.billTableValue = [];
    let billOriginSearchParams = deepCopy(this.billOriginParams);
    billOriginSearchParams.pageSize = this.billPageInfo.pageSize;
    billOriginSearchParams.pageIndex = this.billPageInfo.pageIndex;
    billOriginSearchParams.sortInfo = this.billSortInfo;
    this.isBillLoading = true;
    if (this.selectedDetailRows) {
      if (this.selectedRow.guiId) {
        billOriginSearchParams.guiId = this.selectedRow.guiId;
        for (const originDetailRows of this.cloneDetailTableValue){
          if (originDetailRows.detailRowId == this.selectedDetailRows.detailRowId){
            billOriginSearchParams.accountCode =
          originDetailRows.accountCode;
          }
        }
        this.billOriginParams.guiId = this.selectedRow.guiId;
        this.billOriginParams.accountCode = this.selectedDetailRows.accountCode;
        this.govermentUniformInvoiceCheckService
          .getBillingOriginData(billOriginSearchParams)
          .subscribe({
            next: (result) => {
              this.billTableValue = result;
              const pageList = result.content;
              this.billTableValue = deepCopy(pageList);
              this.putBillRowId(this.billTableValue);

              this.cloneBillTableValue = deepCopy(pageList);
              this.putBillRowId(this.cloneBillTableValue);

              //更改總數量資料
              this.billPageInfo.totalRecords = result.totalElements;
              this.selectedBillRows = this.billTableValue[0];
              this.isSearchFormOpen = false;
              this.isBillLoading = false;
            },
          });
      } else {
        this.billTableValue = [];
        this.selectedBillRows = [];
      }
    } else {
      this.isBillLoading = false;
      this.billTableValue = [];
      this.selectedBillRows = [];
    }
  }

  switchHeaderEditMode() {
    if (this.editMode) {
      if (this.detailNotSaveConfirm() || this.notSaveConfirm()) {
        this.confirmationService.confirm({
          message: this.translateService.instant(
            'EvidenceCheck.Confirm.SaveOrNot'
          ),
          header: this.translateService.instant('EvidenceCheck.Confirm.Header'),
          icon: 'pi pi-info-circle',
          accept: async () => {
            await this.saveDetailChange();
            await this.saveChange();
          },
          reject: (type: any) => {
            switch (type) {
              case ConfirmEventType.REJECT:
                this.resetPageInfo();
                this.sendSearchRequest();
                break;
              case ConfirmEventType.CANCEL:
                break;
            }
          },
        });
      } else {
        this.dataTable.cancelRowEdit(this.selectedRow);
        this.detailDataTable.cancelRowEdit(this.selectedDetailRows);
        this.editMode = false;
        this.resetPageInfo();
        this.sendSearchRequest();
      }
    } else if (this.selectedRow) {
      this.editStatus = this.selectedRow.status;
      if (
        this.editStatus == 0 ||
        this.editStatus == 1 ||
        this.editStatus == 2 ||
        this.editStatus == 6 ||
        this.editStatus == 8
      ) {
        this.dataTable.initRowEdit(this.selectedRow);
      }
      this.previousSelectedRow = deepCopy(this.selectedRow);
      this.previousDetailSelectedRow = deepCopy(this.selectedDetailRows);
      this.editMode = true;
    }
  }

  async saveBtnClick() {
    this.confirmationService.confirm({
      message: this.translateService.instant('EvidenceCheck.Confirm.Save'),
      header: this.translateService.instant('EvidenceCheck.Confirm.Header'),
      icon: 'pi pi-info-circle',
      accept: async () => {
        this.isHeaderLoading = true;
        this.isDetailLoading = true;
        this.isBillLoading = true;
        await this.saveChange();
        await this.saveDetailChange();
      },
    });
  }

  async saveChange() {
    this.saveSuccess = false;
    let updateDataArr = [];
    this.updateGUIID = [];
    var errorGuiNoList = [];

    for (const rowVal of this.tableValue) {
      for (const cloneRowVal of this.cloneTableValue) {
        if (rowVal.rowId == cloneRowVal.rowId) {
          if (JSON.stringify(rowVal) != JSON.stringify(cloneRowVal)) {
            if (rowVal.guiNo.length > 30) {
              errorGuiNoList.push(rowVal.guiNo);
              break;
            }

            const updateData = {
              guiId: rowVal.guiId,
              guiAmount: rowVal.guiAmount,
              guiNo: rowVal.guiNo,
              dueDt: rowVal.dueDt,
              guiDt: rowVal.guiDt,
              guiCurrency: rowVal.guiCurrency,
              shippingDescription: rowVal.shippingDescription,
              amountDifferenceDescription: rowVal.amountDifferenceDescription,
              updateUser: this.userProfile.userName,
              description: rowVal.description,
            };
            updateDataArr.push(updateData);
            this.updateGUIID.push(rowVal.guiId);
          }
        }
      }
    }

    if (errorGuiNoList.length > 0) {
      const instantMsg = await this.translateService.get("EvidenceCheck.Message.GuiNoMaxLength").toPromise();
      this.toastErrorMessage(instantMsg);
      this.isHeaderLoading = false;
      this.isDetailLoading = false;
      this.isBillLoading = false;
      return;
    }

    try{
      await this.govermentUniformInvoiceCheckService.updateGovermentUniformInvoice(updateDataArr);
      this.saveSuccess = true;
    } catch (exception){
      this.saveSuccess = false;
      let errorDesc:any = exception;
      this.toastErrorMessage(errorDesc.error);
      this.isHeaderLoading = false;
      this.isDetailLoading = false;
      this.isBillLoading = false;
    }
  }

  notSaveConfirm(): boolean {
    if (this.editMode) {
      for (const rowVal of this.tableValue) {
        for (const cloneRowVal of this.cloneTableValue) {
          if (rowVal.rowId == cloneRowVal.rowId) {
            if (JSON.stringify(rowVal) != JSON.stringify(cloneRowVal)) {
              return true;
            }
          }
        }
      }
      return false;
    } else {
      return false;
    }
  }

  detailNotSaveConfirm(): boolean {
    if (this.editMode) {
      for (const rowVal of this.detailTableValue) {
        for (const cloneRowVal of this.cloneDetailTableValue) {
          if (rowVal.detailRowId == cloneRowVal.detailRowId) {
            if (JSON.stringify(rowVal) != JSON.stringify(cloneRowVal)) {
              return true;
            }
          }
        }
      }
      return false;
    } else {
      return false;
    }
  }

  selectAllOrUnSelectAll(event: any) {
    if (this.headerChecked) {
      this.selectedRowsWithCheckBox = this.tableValue;
    } else {
      this.selectedRowsWithCheckBox = [];
    }
    this.countTotalRow(event);
  }

  selectDetailAllOrUnSelectDetailAll(event: any) {
    if (this.detailChecked) {
      this.selectedDetailRowsWithCheckBox = this.detailTableValue;
    } else {
      this.selectedDetailRowsWithCheckBox = [];
    }
  }

  onRowClick(rowData: any) {
    this.selectedRow = rowData;
    if (this.editMode) {
      this.doSwitchRow();
    }
  }

  detailOnRowClick(rowData: any) {
    this.selectedDetailRows = rowData;
    if (this.editMode) {
      this.detailDoSwitchRow();
    }
  }

  doSwitchRow() {
    this.dataTable.cancelRowEdit(this.previousSelectedRow);
    this.detailDataTable.cancelRowEdit(this.previousDetailSelectedRow);
    this.editStatus = this.selectedRow.status;
    if (
      this.editStatus == 0 ||
      this.editStatus == 1 ||
      this.editStatus == 2 ||
      this.editStatus == 6 ||
      this.editStatus == 8
    ) {
      this.dataTable.initRowEdit(this.selectedRow);
    }
    this.previousSelectedRow = deepCopy(this.selectedRow);
  }

  detailDoSwitchRow() {
    this.detailDataTable.cancelRowEdit(this.previousDetailSelectedRow);
    this.editStatus = this.selectedRow.status;
    if (
      this.editStatus == 0 ||
      this.editStatus == 1 ||
      this.editStatus == 2 ||
      this.editStatus == 6 ||
      this.editStatus == 8
    ) {
      this.detailDataTable.initRowEdit(this.selectedDetailRows);
    }
    this.previousDetailSelectedRow = deepCopy(this.selectedDetailRows);
  }

  async saveDetailChange() {
    let updateDataArr = [];
    this.updateDetailGUIId = [];
    this.detailDataTable.cancelRowEdit(this.selectedDetailRows);
    for (const rowVal of this.detailTableValue) {
      for (const cloneRowVal of this.cloneDetailTableValue) {
        if (rowVal.detailRowId == cloneRowVal.detailRowId) {
          if (JSON.stringify(rowVal) != JSON.stringify(cloneRowVal)) {
            const updateData = {
              seqNo: rowVal.seqNo,
              invoiceType: rowVal.invoiceType,
              accountCode: rowVal.accountCode,
              salerNo: rowVal.salerNo,
              salerName: rowVal.salerName,
              formatType: rowVal.formatType,
              taxCode: rowVal.taxCode,
              vatCode: rowVal.vatCode,
              amount: rowVal.amount,
              guiTaxAmount: rowVal.guiTaxAmount,
              updateUser: this.userProfile.userName,
              description: rowVal.description,
              guiAmountWithoutTax: rowVal.guiAmountWithoutTax,
              guiAmount: rowVal.guiAmount,
              expressBill: rowVal.expressBill,
              importDeclarationNo: rowVal.importDeclarationNo,
              cutCode: rowVal.cutCode,
              lineDescription: rowVal.lineDescription,
            };
            updateDataArr.push(updateData);
            if (!this.updateDetailGUIId.includes(this.selectedRow.guiId)) {
              this.updateDetailGUIId.push(this.selectedRow.guiId);
            }
          }
        }
      }
    }
    try{
      await this.govermentUniformInvoiceCheckService.updateDetailGovermentUniformInvoice(updateDataArr)
      if (this.saveSuccess) {
        this.sendSearchRequest();
        this.editMode = false;
        this.toastService.success(this.translateService.instant('EvidenceCheck.Toast.SaveSuccess'));
      }
    } catch (exception) {
      if (this.saveSuccess) {
        this.editMode = true;
        let errorDesc:any = exception;
        this.toastErrorMessage(errorDesc.error);
      }
      this.isHeaderLoading = false;
      this.isDetailLoading = false;
      this.isBillLoading = false;
    }
  }

  getTaxCodeOptions(optionCode: any) {
    this.facilityService
      .getExpenseOptions('SHT_BILL_ORIGIN.TAX_CODE', optionCode)
      .subscribe({
        next: (result) => {
          this.taxCodeOptions = [...result].map((x: any) => {
            return {
              value:  `${x.optionDesc}`,
              label: `${x.optionDesc}`,
            };
          });
        },
      });
  }

  getTaxCodeOptionsCompare(optionCode: any) {
    this.facilityService
      .getExpenseOptions('SHT_BILL_ORIGIN.TAX_CODE', optionCode)
      .subscribe({
        next: (result) => {
          this.taxCodeOptionsCompare = [...result].map((x: any) => {
            return {
              value:  x.commonAttr1,
              label: `${x.optionDesc}`,
            };
          });
        },
      });
  }



  changeTaxOptions() {
    if (this.selectedDetailRows.accountCode == "1264.0000") {
      if (
        this.selectedDetailRows.taxCode == null ||
        this.selectedDetailRows.taxCode == undefined
      ) {
        this.selectedDetailRows.vatCode = null;
      } else {
        this.getVatCode(this.selectedDetailRows.taxCode);
      }

      return;
    }

    if (
      this.selectedDetailRows.taxCode == null ||
      this.selectedDetailRows.taxCode == undefined
    ) {
      this.selectedDetailRows.guiAmountWithoutTax = null;
      this.selectedDetailRows.guiTaxAmount = null;
      this.selectedDetailRows.vatCode = null;
    } else {
      this.getVatCode(this.selectedDetailRows.taxCode);

      if (this.selectedDetailRows.vatCode == 0) {
        this.selectedDetailRows.guiTaxAmount =
          this.selectedDetailRows.amount * this.selectedDetailRows.vatCode;
        this.selectedDetailRows.guiAmountWithoutTax =
          this.selectedDetailRows.amount;
      } else {
        this.selectedDetailRows.guiTaxAmount =
          Math.round((this.selectedDetailRows.amount * this.selectedDetailRows.vatCode) /
          100 / (1 + this.selectedDetailRows.vatCode / 100));
        this.selectedDetailRows.guiAmountWithoutTax =
          this.selectedDetailRows.amount - this.selectedDetailRows.guiTaxAmount;
      }
    }
  }

  getDetailTableAccountCodeOption() {
    this.facilityService
      .getAccountCodeOptions('FLOW_BILL_TYPE', this.selectedRow.facility)
      .subscribe({
        next: (result) => {
          this.accountCodeBigOptions = [...result].map((x: any) => {
            return {
              value: `${x.commonAttr05}`,
              label: `${x.commonAttr05}-${x.commonAttr01}`,
            };
          });
        },
      });
  }

  isDisabledUpdate(): boolean {
    return this.selectedRowsWithCheckBox.some((x) => x.status === 'G');
  }

  isDisabledResendUpdate(): boolean {
    return (
      this.selectedRowsWithCheckBox.some((x) => x.status === 'G') &&
      !this.selectedRowsWithCheckBox.every((x) => x.status === 'G')
    );
  }

  countTotalRow(event: any) {
    this.selectedRowCount = 0;
    this.selectedRowTotal = 0;
    this.selectedRowCount = this.selectedRowsWithCheckBox.length;
    for (let selectedRowData of this.selectedRowsWithCheckBox) {
      if (selectedRowData.guiAmount) {
        this.selectedRowTotal =
          this.selectedRowTotal + selectedRowData.guiAmount;
      }
    }
  }

  resetPageInfo() {
    this.pageInfo = {
      pageSize: this.dataTable.rows ?? 100,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
    this.first = 0;
  }

  getVatCode(taxCdoe :any) {
    for (const val of this.taxCodeOptionsCompare){
      if(taxCdoe == val.label){
        this.selectedDetailRows.vatCode = deepCopy(Number(val.value));
      }
    }
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'guiNoDt':
        this.searchForm.get('guiDtStart')?.setValue(startOfDay(date.startDate));
        this.searchForm.get('guiDtEnd')?.setValue(startOfDay(date.endDate));
        break;
      case 'createDt':
        this.searchForm.get('createDtStart')?.setValue(startOfDay(date.startDate));
        this.searchForm.get('createDtEnd')?.setValue(startOfDay(date.endDate));
        break;
    }
  }
}
